import React from 'react';
import { Link } from 'react-router-dom';

function HeaderMinimal(props) {
	return (
		<>
			<div className="container-header-minimal">
				<Link to="/" className="logo-redirection">
					<div className="logo-header-minimal"></div>
				</Link>
			</div>
		</>
	);
}

export default HeaderMinimal;
